import promoModal from './PromotionModal.hbs';
import * as bannerService from '/source/js/services/bannerService';

export function bindModal(referenceId) {
    let bannerResolver = bannerService.getPromotionBannerModal(referenceId);
    Promise.resolve(bannerResolver).then(function (result) {
        let modalData = {
            bannerModal: result
        };
        let modalHtml = promoModal(modalData);
        $('#promotion-modal').html('');
        $('#promotion-modal').html(modalHtml);
        $('#promotion-cta-modal').modal();
    });
}
